import TablePage from '@/found/components/table_page';
import Form from '../form';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  name: 'pro_sg_terminalStock',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('terminal_stock_list');
  },

  methods: {
    modalClick({ val, row }) {
      if (val.code === 'terminal_stock_record') {
        console.log(row.id);
        this.modalConfig.title = '扫码明细';
        this.propsObjInData.id = row.id;
        this.openFull();
      }
    },
  },
};
